<template>
  <div class="pg_header_title program_guide_title">
    <label id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="programGuide.title">
      {{programGuide.title}}
    </label>

    <template v-if="isBookmarkEnabled && programGuide && programGuide.uuid">
      <span
        v-if="isBookmarked(programGuide)"
        @click.stop.prevent="deleteProgramGuideBookmark(programGuide)"
        class="ic_bm_container bookmarked ace_sec_txt"
        title="remove this from bookmark">
          <span class="ic8-bookmark3"></span>
      </span>
      <span v-else
        @click.stop.prevent="bookmarkProgramGuide(programGuide)"
        class="ic_bm_container ace_sec_txt"
        title="bookmark this">
          <span class="ic8-bookmark3"></span>
      </span>
    </template>

    <b-link class="lnk_program_report" @click="exportProgramReport" v-if="isAdminLogin && isDownloadProgramReportEnabled">
      <span>[Export Program Report]</span>
    </b-link>

    <b-popover target="programGuideTitle" triggers="hover" placement="top" class="title_popup" container="programGuideTitleContainer">
      <div class="title_container">
        {{programGuide.title}}
      </div>
    </b-popover>
    <div id="programGuideTitleContainer" class="title_container_popup"></div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import { mapActions, mapState } from 'vuex'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-guide-title',
    props: ['programGuide'],
    data: () => {
      return {
        userId: localStore.getItem('userid'),
        loading: false
      }
    },
    computed: {
      ...mapState({
        'bookmarks': state => state.explore.bookmarks,
        'packages': state => state.institution.packages,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      isAdminLogin () {
        return (localStorage.getItem('userrole') === 'Instructor & Admin')
      },
      isDownloadProgramReportEnabled () {
        let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'Allow Download Program Report')
          })
          return found ? found.enabled : false
        }
        return false
      },
      isBookmarkEnabled () {
        let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
        if (bookmarkFeature && bookmarkFeature.enabled) {
          return true
        }
        return false
      }
    },
    methods: {
      ...mapActions([
        'loadAllBookmarks',
        'loadCreateBookmarks',
        'loadDeleteBookmark',
        'exportProgramReportToCsv'
      ]),
      getBookmark (programGuide) {
        let target = _.find(this.bookmarks, (bookmark) => {
          return (bookmark.entityUuid === programGuide.uuid)
        })
        return target
      },
      isBookmarked (programGuide) {
        programGuide.bookmark = this.getBookmark(programGuide)
        return programGuide.bookmark && programGuide.bookmark.uuid
      },
      showLoader () {
        this.loading = true
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        this.loading = false
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      async bookmarkProgramGuide (programGuide) {
        const bookmark = {
          source: 'explore',
          entityType: 'programguide',
          entityTitle: programGuide.title,
          entityUuid: programGuide.uuid,
          institutionId: programGuide.institutionId,
          userId: this.userId
        }
        const response = await this.loadCreateBookmarks(bookmark)
        const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + programGuide.title + '\''
        const notify = response ? this.notifySuccess : this.notifyFailure
        notify(message)
        await this.loadAllBookmarks()
      },
    writeFile (data) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = this.programGuide.title + ' Report.csv'
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    exportProgramReport () {
      this.showLoader()
      this.exportProgramReportToCsv(this.programGuide.uuid).then(response => {
        let summaryCsvFile = response && response.fileContents ? response.fileContents : response
        let errors = response && response.error ? response.error : ''
        let warnings = response && response.warning ? response.warning : ''
        if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
          this.hideLoader()
          return this.notifyFailure(errors)
        }
        this.writeFile(summaryCsvFile)
        if (warnings && warnings.length > 0) {
          this.notifyWarning(warnings)
          this.hideLoader()
        } else {
          this.notifySuccess('Program Report Successfully Exported to Csv')
          this.hideLoader()
        }
      })
    },

      async deleteProgramGuideBookmark (programGuide) {
        await this.loadDeleteBookmark(programGuide.bookmark.uuid)
        this.notifySuccess('Successfully deleted bookmark \'' + programGuide.title + '\'')
        await this.loadAllBookmarks()
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideTitle.vue